import React from "react";
import { Button } from '../../atoms/Button';

import './LocationCards.scss';
import map from '../../assets/images/map.jpg';
import rightarrow from '../../assets/images/icon-right-arrow.svg';
import rightarrowwhite from '../../assets/images/icon-right-arrow-white.svg';
import phoneicon from '../../assets/images/icon-phone.svg';
import faxicon from '../../assets/images/icon-fax.svg';

export const LocationCards = (props) => {
  const { name, address1, address2, city, state, zip, phone, fax, imageUrl, url, directionsUrl, locationClick } = props;
  return (
    <div className="location_cards">
      <div className="location_cards_content">
        <div className="content_wrap">
          <div className="image_wrap">
            <a target="_blank" href={directionsUrl}>
              <img className="location_map_img" src={imageUrl} alt={`${name}`} />
            </a>
          </div>
          <div className="text_wrap">
            <h2><a onClick={locationClick} href={url}>{name}</a></h2>
            <address>
              <div>{address1}</div>
              <div>{address2}</div>
              <div>{city}, {state} {zip}</div>
            </address>
            <div className="location_cards_direction">
              <a className="icon_center" target="_blank" href={directionsUrl}>
                Get Directions  <img width="10" height="10" className="direction_icon" src={rightarrow} alt="" />
              </a>
            </div>
            <div className="location_contact_info icon_center">
              <a className="icon_center" href={`tel:${phone}`}>
                <img width="10" height="10" className="phone_icon" src={phoneicon} alt="" /> <span>Call</span> {phone}
              </a>
              {fax && <span className="icon_center">
                <img width="10" height="10" className="fax_icon" src={faxicon} alt="" /> <span>Fax</span> {fax}
              </span>}
            </div>
          </div>
          <a onClick={locationClick} href={url} className="location_cta_btn">
            <img width="16" height="16" className="direction_icon" src={rightarrowwhite} alt="" />
          </a>
        </div>
      </div>
    </div>
  );
};